import React, { Component } from 'react';
import { connect } from "react-redux";
import {switchToPattern} from 'engine/mix/actions.js';
const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

class PatternButtons extends Component {
    switchPattern(i) {
        let {sequencerEngine} = this.props;
        sequencerEngine.multiSequencerEngine.dispatch(
            switchToPattern(
                sequencerEngine.sequenceId,
                sequencerEngine.currentSubSequence.id,
                i));
    }

    chooseSubSequence(id) {
        this.props.sequencerEngine.switchToSubSequence(id);
    }

    getSubSequencesComponent() {
        let subSequences = this.props.subSequences || [];
        return (<div className="sub-sequence-buttons">
                {subSequences.map(
                  (id, i) =>
                      <div
                            key={NAMES[i]}
                            onClick={() => this.chooseSubSequence(id)}
                            className={id === this.props.currentSubSequence ?
                                      "sub-sequence selected" : "sub-sequence"}>
                        {NAMES[i]}</div>)}
                </div>
               );
    }

    render() {
        if (this.props.sequencerEngine.tracks[0] === undefined) {
            return this.getSubSequencesComponent();
        }
        return (
            <div>
              <div className="pattern-buttons">
                {this.props.sequencerEngine.tracks[0].patterns.map(
                    (p, i) =>
                        <div
                          style={
                              this.props.color &&
                                  this.props.currentPattern === i ? {backgroundColor: this.props.color} : {}
                          }
                              onClick={() => this.switchPattern(i)}
                              className={this.props.currentPattern === i ? "current pattern-button" : "pattern-button"}>
                          {i + 1}</div>)}
            </div>
                {this.getSubSequencesComponent()}
           </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    let sequenceId = props.sequencerEngine.engineId;
    let subSequenceId = props.sequencerEngine.currentSubSequence.id;
    let currentPattern = state.sequencer.currentPattern[subSequenceId] || 0;
    return {
        currentPattern: currentPattern,
        subSequenceId: subSequenceId,
        subSequences: state.sequencer.subSequences[sequenceId],
        currentSubSequence: state.sequencer.currentSubSequence[sequenceId],
    };
};
 
export default connect(mapStateToProps, null)(PatternButtons);
